module.exports = __webpack_public_path__ + "img/cashflow-after-change.f7232f72.svg";